// ...existing code...
import { pathTranslations, reverseSegmentTranslations } from "./routing";

/**
 * Pure helper functions for translating path segments.
 * These functions import only pure translation maps and contain no
 * server-only APIs, so they are safe to import from client components.
 */
export function reverseTranslateSegments(path, lang) {
  const segments = path.split('/').filter(Boolean);
  const reversedSegments = segments.map(
    (segment) => reverseSegmentTranslations[lang]?.[segment] || segment
  );
  return '/' + reversedSegments.join('/');
}

export function translateSegments(path, lang) {
  if (typeof path !== 'string') {
    path = path.pathname || '';
  }

  const segments = path.split('/').filter(Boolean);
  const translatedSegments = segments.map(
    (segment) => pathTranslations[segment]?.[lang] || segment
  );
  return '/' + translatedSegments.join('/');
}

